import "vuetify/lib/styles/main.css";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import * as components from "vuetify/lib/components/index.js";
import * as directives from "vuetify/lib/directives/index.js";
import * as labsComponents from "vuetify/lib/labs/components.js";
import { zhHans } from "vuetify/lib/locale/index.js";

export default createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  locale: {
    locale: "zhHans",
    messages: { zhHans },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#1976D2",
          secondary: "#424242",
          accent: "#82B1FF",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
      },
    },
  },
});
